export const ServicePeriodStatus = {
	PUBLISHED: "Published",
	COMPLETED: "Completed",
	DRAFT: "Draft",
} as const;

export type ServicePeriodStatusValue =
	(typeof ServicePeriodStatus)[keyof typeof ServicePeriodStatus];

export const UnitPayoutStatus = {
	SETTLED: "Settled",
	IN_PROGRESS: "In Progress",
	HOLD: "Hold",
	PARTIALLY_PAID: "Partially Paid",
	PAST_DUE: "Past Due",
} as const;

export type UnitPayoutStatusValue =
	(typeof UnitPayoutStatus)[keyof typeof UnitPayoutStatus];

export const ChargesCategory = {
	COMMON_AREA: "Common Area Charges",
	UTILITIES: "Utilities",
	MANDATORY: "Mandatory Charges",
} as const;

export type ChargesCategoryValue =
	(typeof ChargesCategory)[keyof typeof ChargesCategory];

export interface FinancialPropertyListItem {
	id: string;
	name: string;
	totalUnits: number;
	latestServicePeriodLabel: string;
	status: ServicePeriodStatusValue;
	lastUpdatedDate: string;
	approver: string;
	/** Charges only */
	chargesCategory?: ChargesCategoryValue;
}

export interface ServicePeriodListItem {
	id: string;
	propertyId: string;
	periodLabel: string;
	dueDate?: string;
	paidUnitsLabel: string;
	status: ServicePeriodStatusValue;
	createdDate: string;
	lastUpdatedBy: string;
	lastUpdatedDate: string;
	approver: string;
	uploadedAtLabel?: string;
}

export interface RevenueUnitListItem {
	id: string;
	unitCode: string;
	ownerName: string;
	ownerEmail: string;
	nights: number;
	netRevenue: number;
	ownerShare: number;
	balanceToPay: number | null;
	payoutMethod: string;
	status: UnitPayoutStatusValue;
	isPaid?: boolean;
}

export interface ChargesUnitListItem {
	id: string;
	unitCode: string;
	ownerName: string;
	ownerEmail: string;
	amount: number;
	partialPayment: number | null;
	remainingLabel: string;
	isFullyPaid: boolean;
	paymentMethod: string;
	status: UnitPayoutStatusValue;
}

export interface ChargeLineItem {
	category: string;
	description: string;
	amount: number;
	tax: number;
	total: number;
}

export interface ChargesUnitDetail {
	id: string;
	propertyId: string;
	periodId: string;
	invoiceNumber: string;
	unitCode: string;
	ownerName: string;
	ownerInitials: string;
	ownerPhone: string;
	ownerEmail: string;
	unitDetail: string;
	status: UnitPayoutStatusValue;
	servicePeriodLabel: string;
	invoiceDate: string;
	paymentDate: string;
	lineItems: ChargeLineItem[];
	totalAmount: number;
}

export interface RevenueUnitDetail {
	id: string;
	propertyId: string;
	periodId: string;
	statementId: string;
	unitCode: string;
	ownerName: string;
	ownerInitials: string;
	ownerPhone: string;
	ownerEmail: string;
	unitDetail: string;
	status: UnitPayoutStatusValue;
	servicePeriodLabel: string;
	statementDate: string;
	payoutDate: string;
	rentalActivityRows: RentalActivityRow[];
	rentalSummaryRows: RentalSummaryRow[];
	totalAmountToTransfer: number;
}

export interface RentalActivityRow {
	id: string;
	period: string;
	unit: string;
	type: string;
	arrival: string;
	departure: string;
	resvNights: number | string;
	netRoomRevenue: number | string;
}

export interface RentalSummaryRow {
	id: string;
	lineItem: string;
	oct: number | string;
	nov: number | string;
	dec: number | string;
	total: number | string;
	isDeduction?: boolean;
	isSubtotal?: boolean;
	isGrandTotal?: boolean;
}
